var React = require('react');

function Minimize (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4.5625 14.4237H10.5625V20.4237","stroke":"#CF2029","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M20.5625 10.4237H14.5625V4.42368","stroke":"#CF2029","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M14.5625 10.4237L21.5625 3.42368","stroke":"#CF2029","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M3.5625 21.4237L10.5625 14.4237","stroke":"#CF2029","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

Minimize.defaultProps = {"preserveAspectRatio":"xMinYMin meet","viewBox":"0 0 25 25","fill":"none"};

module.exports = Minimize;

Minimize.default = Minimize;
